import { List } from 'immutable'
import { AsyncState, unloadedAsyncState } from 'widgets-for-react'
import { getDrupalLanguage, Locale, ParsedMenuItem } from '../../drupal/types_and_parser/extra_types.mod'
import { getLangFromUrl } from '../utils/history.mod'

export type HeaderState = {
  mode: 'closed' | 'open'
  countriesNav: 'closed' | 'open'
  searchNav: 'closed' | 'open'
  selectRegionNav: 'closed' | 'open'
  menuHeader: {
    navLinks: AsyncState<List<ParsedMenuItem>>
    languages: AsyncState<List<string>>
  }
  topMenu: AsyncState<List<ParsedMenuItem>>
  countryMenu: AsyncState<List<ParsedMenuItem>>
  currentLanguage: Locale
  hoveredPrimMenuItem?: ParsedMenuItem
  hoveredSecMenuItem?: ParsedMenuItem
  searchQuery: string
}

export const initialHeaderState: HeaderState = {
  mode: 'closed',
  countriesNav: 'closed',
  searchNav: 'closed',
  selectRegionNav: 'closed',
  menuHeader: {
    navLinks: unloadedAsyncState(),
    languages: unloadedAsyncState() //loadingAsyncState(() => Api.loadLanguages()),
  },
  currentLanguage: getDrupalLanguage(getLangFromUrl()),
  topMenu: unloadedAsyncState(), //loadingAsyncState(() => Api.loadTopMenu())
  countryMenu: unloadedAsyncState(), //loadingAsyncState(() => Api.loadTopMenu())
  searchQuery: ''
}
